import Application from '../suite/common'

export default {
    DEFAULT: 'Hover over any link to learn more about each item',
    [Application.AdsManager]: 'Analyze and manage your advertising campaigns',
    [Application.Reports]: 'Generate reports related to your advertising campaigns',
    [Application.QPixel]: 'Configure tracking of events and conversions associated with this account',
    [Application.Planner]: 'Create new audiences or manage your saved and uploaded Quantcast audiences',
    [Application.Inventory]: 'Manage your site lists, IP lists, and brand safety',
    [Application.CreativeLibrary]: 'Upload new creatives or view all existing creatives for your advertising campaigns'
}
